import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { useGetSingleAvailableCohortReportsQuery } from "../../store/api/core";
import { useParams } from "react-router-dom";
import { useRestrictionSetup } from "../../hooks/restrictionSetup"; // Pushing code so for formatting commenting out
import { FilterContext } from "../../providers/FilterProvider";
import { hasPermissionExist } from "../../store/api/permissions";
import { useCohortAssessmentCategoryFilter } from "../../hooks/cohortAssessmentCategoryFilter";
export var CohortRestrictions = function (_a) {
    var _b;
    var children = _a.children;
    var reportId = useParams().reportId;
    var response = useGetSingleAvailableCohortReportsQuery({
        reportId: reportId || "",
    }, { shouldSkipCall: function () { return !reportId; } });
    useRestrictionSetup((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.filters);
    useCohortAssessmentCategoryFilter();
    return _jsx(_Fragment, { children: children });
};
// Wrapper to control the leader table visibility based on the
// confidential filter and permission.
export var CohortLeaderTableWrapper = function (_a) {
    var _b;
    var children = _a.children;
    var _c = useState(false), showTable = _c[0], setShowTable = _c[1];
    var reportId = useParams().reportId;
    var reportData = useGetSingleAvailableCohortReportsQuery({
        reportId: reportId || "",
    });
    var getFilters = useContext(FilterContext).getFilters;
    var hasPermission = hasPermissionExist("COHORT_INSIGHTS_API/COHORT_CONFIDENTIAL");
    var filters = getFilters();
    useEffect(function () {
        var _a, _b;
        var isConfidential = filters.confidential != undefined &&
            ((_a = filters.confidential) === null || _a === void 0 ? void 0 : _a[0]) === "false";
        var shouldShowTable = !((_b = reportData === null || reportData === void 0 ? void 0 : reportData.data) === null || _b === void 0 ? void 0 : _b.isConfidential) || (hasPermission && isConfidential);
        setShowTable(shouldShowTable);
    }, [(_b = reportData === null || reportData === void 0 ? void 0 : reportData.data) === null || _b === void 0 ? void 0 : _b.isConfidential, hasPermission, filters]);
    return _jsx("div", { children: showTable ? children : null });
};
